import { useQuery } from '@tanstack/react-query'
import {
	type GetQuoteGenerationListingsParams,
	httpGetQuoteGenerationListings
} from '@/features/luxe-submissions/http/luxe-submissions.http'

export const QUOTE_GENERATION_LISTINGS_QUERY_KEY = 'quote-generation-listings'

export const useGetQuoteGenerationListings = (
	params: GetQuoteGenerationListingsParams = {}
) =>
	useQuery({
		queryKey: [QUOTE_GENERATION_LISTINGS_QUERY_KEY, params],
		queryFn: () => httpGetQuoteGenerationListings(params)
	})
